import { Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import BackgroundImage from "./bg.svg";

export const GameOverContainer = styled(Container)(({ theme }) => ({
	width: "100%",
	height: "100vh",
	padding: "0",
	background: `${theme.palette.primary.light} url(${BackgroundImage}) no-repeat bottom fixed`,
	backgroundAattachment: "fixed",
	backgroundSize: "contain",
	display: "grid",
	gridTemplateRows: "auto",
	gridGap: "1em",
	gridTemplateColumns: "8% minmax(300px, 22%) 55% 15%",
	gridTemplateAreas: `"left-gutter summary detail right-gutter"`,
	[theme.breakpoints.down("md")]: {
		gridGap: "0",
		gridTemplateColumns: "auto",
		gridTemplateRows: "minmax(300px, 25%) 75%",
		gridTemplateAreas: `"summary" "detail"`,
	},
	[theme.breakpoints.down("mobile")]: {
		gridTemplateRows: "none",
		height: "100%",
		marginTop: 41,
	},
	[theme.breakpoints.up("md")]: {
		overflow: "auto",
		gridGap: "1em",
		gridTemplateRows: "auto",
		gridTemplateColumns: "2% minmax(300px, 25%) 60% 10%",
		gridTemplateAreas: `"left-gutter summary detail right-gutter"`,
	},
	[theme.breakpoints.up("lg")]: {
		gridGap: "1em",
		gridTemplateRows: "auto",
		gridTemplateColumns: "minmax(80px, 5%) minmax(300px, 20%) minmax(700px, 55%) minmax(150px, 15%)",
		gridTemplateAreas: `"left-gutter summary detail right-gutter"`,
	},
	[theme.breakpoints.up("xl")]: {
		gridGap: "2em",
		gridTemplateRows: "auto",
		gridTemplateColumns: "minmax(130px, 5%) minmax(300px,20%) minmax(500px, 60%) minmax(130px, 5%)",
		gridTemplateAreas: `"left-gutter summary detail right-gutter"`,
	},
}));

export const SummaryContainer = styled("div")(({ theme }) => ({
	gridArea: "summary",
	height: "100%",
	[theme.breakpoints.down("mobile")]: {
		height: "fit-content",
	},
}));

export const DetailsContainer = styled("div")({
	gridArea: "detail",
});
